<template>
  <div class="work-world">
    <h1 class="home-model-title">工作圈</h1>
    <div class="work-container">
      <ul class="world-list">
        <li v-for="(item,index) in worldList" :key="index" class="world-item">
          <div class="title">
            <span>{{item.name}}</span>
            <span>{{item.time}}</span>
          </div>
          <div class="content">{{item.content}}</div>
        </li>
      </ul>
      <div class="more">
        查看更多
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkWorld',
  data () {
    return {
      worldList: [
        {
          name: '高圆圆',
          time: '2019-5-1-8 16:59:26',
          content:
            '#信息化办公# 在客服体系，想要获得一枚勋章需要考核KPI完成程度、无迟到早退、质检、效能、满意度等多个指标，着实不容易。而在满意度这个关键指标上，梅珍的数据高达99.4%。大家都知道，今年的…'
        },
        {
          name: '高圆圆',
          time: '2019-5-1-8 16:59:26',
          content:
            '#信息化办公# 在客服体系，想要获得一枚勋章需要考核KPI完成程度、无迟到早退、质检、效能、满意度等多个指标，着实不容易。而在满意度这个关键指标上，梅珍的数据高达99.4%。大家都知道，今年的…'
        }
      ]
    }
  },
  methods: {
    sysDel (num) {
      this.sysList.splice(num, 1)
    },
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.work-world{
  margin-bottom: 40px;
}
.home-model-title {
  margin-bottom: 30px;
}
.work-container {
  border: 1px solid rgba(237, 237, 237, 1);
  padding: 20px;
  .more {
    text-align: center;
  }
}
.world-list {
  .world-item {
    .title {
      height: 60px;
    }
    .content {
      height: 50px;
    }
  }
}
</style>
